import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import Schedule, { ISchedule } from 'modules/work_schedules/store/models/Schedule'

class Schedules extends Collection<Schedule> {
  constructor(data: ISchedule[] = []) {
    super(data)
    makeObservable(this, {
      archived: computed,
      unarchived: computed,
    })
  }

  get cacheKey(): string {
    return 'schedules'
  }

  model() {
    return Schedule
  }

  get archived(): Schedule[] {
    return this.models.filter((model: Schedule) => model.archived)
  }

  get unarchived(): Schedule[] {
    return this.models.filter((model: Schedule) => !model.archived)
  }
}

const singleton: Schedules = new Schedules()

export default singleton

const { provider: SchedulesProvider, hook: useSchedules } = createCollectionContext<
  Schedule,
  Schedules
>()

export { SchedulesProvider, useSchedules }
